import React from 'react';
import './Home.css';

const Home = () => {
  const handleLogin = () => {
    console.log(process.env.REACT_APP_SERVICE)
    window.location.href = process.env.REACT_APP_SERVICE+'/login'; // or your SAML login route
  };

  return (
     
    <div className="home-container">

      <div className='toolBar'>
        Welcome to SAML Auth App
      </div>
      <div class="white_box">
      <div>
        <h4>Existing User</h4>
        <button style={{backgroundColor: 'white', color: 'green', width: '200px', height: '60px', boxShadow: 'rgba(0,0,0,.2) 0 4px 12px', border: 'none', borderRadius: '4px'}} onClick={handleLogin}>
          Login with SAML
        </button>
      </div>
      
     
    </div>
      {/* <p className="home-subtitle">Securely login using your SSO credentials</p>
      <button className="home-button"         style={{ backgroundColor: 'green', color: 'white'}}
 onClick={handleLogin}>Login with SAML</button> */}
    </div>
  );
};

export default Home;
